import { showError } from './common';
import axios from 'axios';
import { store } from 'store/index';
import { LOGIN } from 'store/actions';
import config from 'config';

export const API = axios.create({
  baseURL: process.env.REACT_APP_SERVER ? process.env.REACT_APP_SERVER : '/'
});
// ✅ 请求拦截器：自动附加 token
API.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const user = state.account?.user; // 从 Redux 里取当前用户
    if (user?.access_token) {
      config.headers['X-Authorization'] = user.access_token;
      // 或者带在 query 参数里
      // config.params = { ...(config.params || {}), token: user.token };
    }
    return config;
  },
  (error) => Promise.reject(error)
);
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('realUser');
      localStorage.removeItem('user');
      store.dispatch({ type: LOGIN, payload: null });
      window.location.href = config.basename + 'login';
    }

    if (error.response?.data?.message) {
      error.message = error.response.data.message;
    }

    showError(error);
  }
);
